import { styled } from "styled-components";
import { colors } from "../../styles/colors";

export const ContainerProjects = styled.div`
  max-width: 90%;
  margin: 0 auto;
  padding-top: 50px;

  @media (max-width: 768px) {
    padding-top: 10px;
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 30px;

  span {
    font-size: 40px;
    background: linear-gradient(135deg, #000000 0%, #ffe5ae 100%);
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
  }
`;

export const ContentProjectContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 468px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ProjectContent = styled.div`
  padding: 0 10px;
  margin-bottom: 2em;
`;

export const TitleProject = styled.h3`
  padding: 8px 15px;
  font-weight: 200;
  font-size: 22px;
  text-align: center;
  margin-bottom: 0;
  color: #000000;
  text-decoration: none;
`;

export const ContainerImage = styled.div`
  text-align: center;

  img {
    width: 100%;
    height: 200px;
  }

  img:hover {
    opacity: 0.4;
  }

  @media (max-width: 768px) {
    img {
      max-width: 250px;
    }
  }
`;

export const ContainerTechs = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;
  justify-content: space-evenly;

  div {
    text-align: center;
  }

  img {
    width: 35px;
    height: auto;
    margin: 0 5px;
  }

  p {
    margin-top: 2px;
    font-size: 13px;
    color: ${colors.TEXT_GREY_NEUTRAL};
  }
`;

export const Description = styled.div`
  margin-top: -4px;
  color: #000000;
  padding: 12px;
  text-align: justify;
  height: 100px;
`;

export const ContainerFooter = styled.div`
  display: flex;
  margin-top: 10px;

  img {
    width: 35px;
  }

  a:first-of-type {
    padding: 0 20px;
  }
`;
